
export enum CampaignType {
  Email = 1,
  RegularEmail = 2,
  TextMessaging = 3,
  Facebook = 4,
  Twitter = 5,
  Instagram = 6,
  Letter = 7
}